import { useTranslation } from "react-i18next";

const TamiasFor = ({ direction }) => {
  const isRight = direction === "text-right";
  const { t } = useTranslation();
  const points = t("tamiasForSection.points", { returnObjects: true });

  return (
    <section id="TamiasFor" className="service padding-y-120 position-relative z-index-1">
      
      <div className="container container-two">
        <div
          className={`row gy-4 align-items-center flex-wrap ${
            isRight ? "flex-row-reverse flex-wrap-reverse" : ""
          }`}
        >
          <div className="col-xl-5">
            <img src={`/assets/images/thumbs/tamias-for-sectionImg.webp`} alt=""/>
          </div>
          <div className="col-xl-1 d-xl-block d-none" />
          <div className="col-xl-6">
            <div className="section-content">
              <div className="section-heading style-left">
                <h3 className="section-heading__title">{t("tamiasForSection.title")}</h3>
                <p className="section-heading__desc font-18 w-sm">
                    {t("tamiasForSection.desc.0")}
                </p>

                <p className="section-heading__desc font-18 w-sm">{t("tamiasForSection.desc.1")}</p>

                 <ul>
                  {points.map((point, index) => (
                    <li className="custom-points" key={index}>
                      <img
                        src="/assets/images/icons/circle-tick-orange.svg"
                        alt="Tick icon"
                        className="custom-points-icon"
                      />
                      <div>
                        <h5 className="service-item__title my-3 font-18">
                          {point}
                        </h5>
                      </div>
                    </li>
                  ))}
                </ul>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default TamiasFor;

